import { render, staticRenderFns } from "./ProviderManagement.vue?vue&type=template&id=44ead060&scoped=true"
import script from "./ProviderManagement.vue?vue&type=script&lang=js"
export * from "./ProviderManagement.vue?vue&type=script&lang=js"
import style0 from "./ProviderManagement.vue?vue&type=style&index=0&id=44ead060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ead060",
  null
  
)

export default component.exports